import Breadcrumb from "../Component/Breadcrumb";

function About() {
  return (
    <>
      <Breadcrumb></Breadcrumb>

      <div className="innersec about_sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>About</h1>
            </div>
            <p className="about-text">
              <img
                src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png"
                className="col-md-4 float-md-end left-img img-fluid"
              />
              <strong>St. Joseph’s school, Barhalganj</strong>, affiliated to
              the central board of secondary education, New Delhi (aff. no.
              2131498) is an English medium Christian minority educational
              institution established in 2007, administered and governed by the
              Catholic diocese of Gorakhpur education society, registered under
              the society's registration act. Being governed by the Catholic
              church a minority community, the school has the primary objective
              of educating the children of the community. However, we shall not
              spare any effort in rendering our service to all people,
              irrespective of caste and gender, so as to conserve their
              religion, language and culture.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
